module.exports = __webpack_public_path__ + "static/media/point.131a8ba2.png";